import React from 'react';
import withRouter from '../DataContext/withRouter';
class ScrollToTop extends React.Component {
  componentDidUpdate(prevProps) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      var element = document.getElementById("scrollable");
      element.scrollTop = 0;
      // window.scrollTo(0, 0);
    }
  }

  render() {
    return this.props.children;
  }
}

export default withRouter(ScrollToTop);
